
function PickupController() {
    this.init.apply(this, arguments);
}

PickupController.$inject = ['$scope', '$mdDialog', 'Upload', '$q', '$state', '$stateParams', 'AttackmentService', 'VehicleBookingService', '$message', '$mdToast', '$Loading', '$timeout', '$interpolate', '$translationService', 'CameraService', 'UtilityService', '$mdPanel', '$ionicScrollDelegate', 'ChargeRequestService'];
PickupController.prototype = {
    type: 'pickup',
    /**
     *
     * @param $scope
     * @param $mdDialog {$mdDialog}
     * @param Upload
     * @param $q {angular.IQService}
     * @param $state
     * @param $stateParams
     * @param AttackmentService {AttackmentService}
     * @param VehicleBookingService {VehicleBookingService}
     * @param $message
     * @param $mdToast
     * @param $Loading {$Loading}
     * @param $timeout
     * @param $interpolate
     * @param $translationService {$translationService}
     * @param CameraService {CameraService}
     * @param UtilityService {UtilityService}
     * @param $mdPanel {$mdPanel}
     * @param $ionicScrollDelegate {$ionicScrollDelegate}
     * @param ChargeRequestService {ChargeRequestService}
     */
    init($scope, $mdDialog, Upload, $q, $state, $stateParams, AttackmentService, VehicleBookingService, $message, $mdToast, $Loading, $timeout, $interpolate, $translationService, CameraService, UtilityService, $mdPanel, $ionicScrollDelegate, ChargeRequestService) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.Upload = Upload;
        this.$q = $q;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.attackmentService = AttackmentService;
        this.vehicleBookingService = VehicleBookingService;
        this.$message = $message;
        this.$mdToast = $mdToast;
        this.$Loading = $Loading;
        this.$timeout = $timeout;
        this.$interpolate = $interpolate;
        this.$translationService = $translationService;
        this.cameraService = CameraService;
        this.utilityService = UtilityService;
        this.$mdPanel = $mdPanel;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.chargeRequestService = ChargeRequestService;


        /** @type {IPickUpReturnSave} */
        this.item = {
            VehicleBookingId: this.$stateParams.id,
            Date: moment().format('YYYY-MM-DD'),
            Time: moment().format('HH:mm')
        };

        /** @type string */
        this.title = '';
        if (this.type === 'pickup') {
            this.title = this.$translationService.getTranslation("PickUpVehicle");
        } else {
            this.title = this.$translationService.getTranslation("ReturnVehicle");
        }



        /** @type {IVehicleProcedure} */
        this.vehicleProcedure = {};

        /** @type {IVehicleDamage[]} */
        this.vehicleDamages = [];

        /** @type {IAttachment[]} */
        this.$files = [];

        /** @type {IAttachment[]} */
        this.$existingDamages = [];

        //Get root element of this page
        this.$element = this.getElement();



        //Get a booking from id
        this.getData()
            .finally(this.$Loading.blockUI())
            .then(() => {
            }, this.$message.error);
    },

    getElement() {
        return $("#internal-pickup-return-page");
    },

    /**
     * Go to to prev page
     */
    goBack() {
        this.$state.go("internal.vehiclebookings", JSON.parse(this.$stateParams.state));
    },

    /**
     * Show thank message after save data
     * @param {MouseEvent} $event
     * @returns {angular.IPromise<any>}
     */
    showThanks($event) {
        return this.$mdDialog.show(this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .textContent(this.$translationService.getTranslation('EnjoyYourRide'))
            .ok(this.$translationService.getTranslation('OK'))
            .targetEvent($event));
    },


    /**
     * Prepare data before save
     * @returns {IPickUpReturnSave}
     */
    prepareDataToSave() {
        return {
            VehicleBookingId: this.item.VehicleBookingId,
            // Date: this.item.Date,
            // Time: this.item.Time,
            OdometerReading: this.item.OdometerReading,
            Questionnaire: this.getQuestionnaire(),
        };
    },

    /**
     * Submit data to save
     * @param $event
     */
    submit($event) {
        //Show files manager if files upload is pending or update fail
        if (!this.attackmentService.checkFiles(this.$files)) {
            return;
        }
        this.save(this.prepareDataToSave(), $event);
    },

    /**
     * Send data to server
     * @param data {IPickUpReturnSave}
     * @param $event
     */
    save(data, $event) {
        this.vehicleBookingService.pickUpBooking(data)
            .then(() => {
                this.showThanks($event).then(() => {
                    this.afterPickupReturnComplete();
                });
            }, (error) => {
                this.showConnectErrorMessage(error);
            })
            .finally(this.$Loading.blockUI({
                title: "Saving"
            }));
    },

    /**
     * Show OdometerReading Message
     * @param error
     */
    showConnectErrorMessage(error) {
        return this.chargeRequestService.handleOdometerReadingError(error).then(()=>{
            let data = this.prepareDataToSave();
            data.BypassValidationOfOdometerReading = true;
            this.save(data);
        });
    },

    /**
     * Get booking by id
     * @returns {any}
     */
    getData() {
        let procedureType ;
        if(this.type==='pickup') {
            procedureType = 'VehicleBookingPickUp';
        } else{
            procedureType = 'VehicleBookingReturn';
        }
        return this.vehicleBookingService.getVehicleBooking(this.$stateParams.id).then((vehicleBooking) => {
            this.vehicleBooking = vehicleBooking;
            return this.vehicleBookingService.getVehicleProcedure(procedureType).then((vehicleProcedure)=>{
                this.vehicleProcedure = vehicleProcedure;
                if(vehicleProcedure.AllowToViewAndAddVehicleDamages){
                    this.vehicleBookingService.getExistingVehicleDamages(this.vehicleBooking.VehicleId).then((vehicleDamages)=>{
                        this.vehicleDamages = vehicleDamages;
                        this.$existingDamages = this.getAttachmentsFromDamages(this.vehicleDamages);
                    })
                }
            });

        })
    },


    /**
     * Show StartDate picker
     * @param $event
     */
    showDatePickerModal($event) {
        this.utilityService.showDatePickerModal(this.item.Date, $event).then((result) => {
            this.item.Date = result;
        })
    },

    /**
     * Show Time picker
     * @param $event
     */
    showTimePicker($event) {
        this.utilityService.showTimePicker(this.item.Time, true, this.$translationService.getTranslation('Time'), $event).then((result) => {
            this.item.Time = result;
        })

    },

    /**
     *
     * @returns {IVehicleQuestionnaireSave}
     */
    getQuestionnaire() {
        /** @type {IVehicleQuestionnaireSave} */
        return {
            VehicleProcedureId: this.vehicleProcedure.Id,
            Answers: this.getAnswers(),
            Damages: this.getDamages()
        };
    },

    /**
     *
     * @returns {IVehicleQuestionnaireAnswerSave[]}
     */
    getAnswers() {
        return this.vehicleProcedure.Lines
            // Only get answer that have value
            .filter((line) => {
                return !(line.Value === undefined || line.Value === null);
            })
            // Map to IVehicleQuestionnaireAnswerSave
            .map((line) => {
                return {
                    VehicleProcedureLineId: line.Id,
                    Answer: this.getAnswerValue(line.Value)
                }
            });
    },

    /**
     * Get damages
     * @returns {IVehicleDamage[]}
     */
    getDamages() {
        return this.vehicleDamages.map((vehicleDamage) => {
            return {
                    Type: vehicleDamage.isNew?'Added':'Existing',
                    VehicleDamageId: vehicleDamage.isNew?vehicleDamage.VehicleDamageId: vehicleDamage.Id,
                    Description: vehicleDamage.Description,
                    Location: vehicleDamage.Location,
                    DocumentId: vehicleDamage.DocumentId,
                    DocumentName: vehicleDamage.DocumentName
                };
            });
    },

    /**
     * Format answer value (have to be string
     * @param value {any}
     * @returns {string}
     */
    getAnswerValue(value) {
        return value + "";
    },

    /**
     * Show edit damage dialog
     * @param damage {IVehicleDamage}
     * @param $event {MouseEvent}
     * @returns {angular.IPromise<IVehicleDamage>}
     */
    onAddEditDamage(damage, $event) {
        return this.$q((resolve)=>{
            let panelRef = this.$mdPanel.create({
                controller: 'AddDamageController',
                controllerAs: 'vm',
                templateUrl: 'js/internal/vehiclebookings/add-damage/add-damage.controller.html',
                parent: angular.element(document.body),
                hasBackdrop: true,
                fullscreen: true,
                escapeToClose: false,
                targetEvent: $event,
                panelClass: 'panel-md-dialog',
                focusOnOpen: false,
                locals: {
                    /**
                     *
                     * @param result {IVehicleDamage}
                     * @returns {*}
                     */
                    close: (result) => {
                        return panelRef.close(result).finally(() => {
                            if (result) { // save damage
                                if (!damage.Id) {
                                    // add
                                    this.vehicleDamages.push(result);

                                    let file = this.vehicleBookingService.getAttachmentFromDamage(result);
                                    this.$files.push(file);

                                } else {
                                    // Edit


                                    // Update current damage
                                    let currentDamage = this.vehicleDamages.find((item) => item.Id === result.Id);
                                    if (currentDamage) {
                                        Object.assign(currentDamage, result);

                                    }

                                    // Update current file
                                    let currentAttachment = this.$files.find((file) => {
                                        return file.Id === result.Id;
                                    });
                                    if (currentAttachment) {
                                        let newAttachment = this.vehicleBookingService.getAttachmentFromDamage(result);
                                        Object.assign(currentAttachment, newAttachment);
                                    }

                                }
                            }
                            resolve(result);
                        })
                    },
                    damage: JSON.parse(JSON.stringify(damage))
                }
            });
            panelRef.open().then((panel) => {
                panel._config.scope.vm.ready();
            });
        })

    },

    onAddDamage($event) {
        this.onAddEditDamage({isNew: true}, $event).then((result) => {
            this.scrollToBottom();
        });
    },


    /**
     * Get attachments from damages
     * @param damages {IVehicleDamage[]}
     * @returns {IAttachment[]}
     */
    getAttachmentsFromDamages(damages) {
        return damages.map((damage) => {
            return this.vehicleBookingService.getAttachmentFromDamage(damage);
        })
    },

    // Set class for damage item
    getClass($file) {
        if (!$file.DocumentId) {
            return "no_image";
        }
    },

    /**
     * Click on file
     * @param $file {IAttachment}
     */
    onFileSelected($file) {
        let damage = this.vehicleDamages.find((damage) => {
            return damage.Id === $file.Id;
        });
        if ($file.isNew) {
            this.onAddEditDamage(damage);
        } else{
            this.vehicleBookingService.onViewDamageDetail(damage);
        }
    },

    scrollToBottom(){
         this.getScroller().scrollBottom();
    },

    getScroller(){
        return this.$ionicScrollDelegate.$getByHandle('pickup-return-scroller');
    },

    /**
     * Update scroller after file is removed
     * @param $file {IAttachment}
     */
    onFileRemoved($file){
        // Check if the file has a valid ID before proceeding
        if ($file && $file.Id) {
            const deleteIndex = this.vehicleDamages.findIndex(damage => damage.Id === $file.Id);

            // Verify if the index is valid before attempting to remove the item
            if (deleteIndex !== -1) {
                this.vehicleDamages.splice(deleteIndex, 1);
            } else {
                console.error(`Damage with ID ${$file.Id} not found.`);
            }
        } else {
            console.error('Invalid file or file ID.');
        }
        this.getScroller().resize();
    },

    afterPickupReturnComplete () {
        // Go to
        this.$state.go("internal.vehiclebookings", {
            id: this.item.VehicleBookingId
        });
    },


}

angular.module('internal.vehiclebookings').controller('PickupController', PickupController);
